import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

import 'next/stylesheets/components/todo-page/breadcrumbs';

Component('tr-todo-page-breadcrumbs', {
  mixins: [eventListenerMixin],

  ready() {
    [...this.querySelectorAll('.breadcrumb-link')].forEach((link) => {
      this.listenTo(link, 'click', (event) => {
        if (!this.namespacedTrigger('openpage', { bubbles: true, detail: { url: link.href } })) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  },

  disconnected() {
    this.stopListening();
  },
});
